module.exports = __webpack_public_path__ + "img/637025808723596383het-nieuwe-werken-overzicht2.png";